export default "__VITE_ASSET__5e55fa54__"